import * as Types from 'src/state/gql/_types';
import { Action, GraphQLSubscriptionResultsPayload } from 'src/state/_types';
import { handleGraphqQLSubscriptionErrorResponse, } from 'src/state/gql/utils';
import { subscriptions } from 'src/state/gql/_operations';
import { mapArrayToStateObject } from 'src/utils/state';

export const syncGetAllItems: Action<Types.SyncGetAllBlackoutsSubscriptionVariables> = async ({state, actions, effects}, payload) => {
    let { orderBy } = state.blackouts.meta;
    state.blackouts.loading = true;
    effects.subscriptions.subscribe<Types.SyncGetAllBlackoutsSubscription, Types.SyncGetAllBlackoutsSubscriptionVariables>(
        'syncGetAllBlackouts', 
        subscriptions.SyncGetAllBlackouts, 
        { ...payload, order_by: orderBy }, 
        actions.blackouts.onAllItemsData,
        () => { state.blackouts.loading = false }
    );
}

export const subscribeToAllItems: Action<Types.SyncGetBlackoutsSubscriptionVariables> = async ({actions}, payload) => {
    actions.blackouts.syncGetAllItems(payload);
    actions.blackouts.syncGetItemsMeta(payload);
}

export const onAllItemsData: Action<GraphQLSubscriptionResultsPayload<Types.SyncGetBlackoutsSubscription>> = async ({state}, payload) => {
    if (payload.error) {
        state.blackouts.errors = [ ...state.blackouts.errors, ...handleGraphqQLSubscriptionErrorResponse(payload.error) ];
    }
    if (payload.data&&payload.data.items) {
        state.blackouts.items = mapArrayToStateObject(payload.data.items, 'id');
    }  
}

export const unsubscribeFromAllItems: Action = ({actions}) => {
    actions.blackouts.unsubAllItemsData();
    actions.blackouts.unsubItemsMeta();
}

export const unsubAllItemsData: Action = ({state,effects}) => {
    effects.subscriptions.unsubscribe('syncGetAllBlackouts');
    state.blackouts.items = {};
}